import http from '../../core/services/http'

export const generateAdvancedProbeCrawlingSessionReport = ({ sessionId }) =>
  http.get(`/reports/advanced-probe-crawling-session/${sessionId}`, {
    responseType: 'blob',
  })

